module.exports = __webpack_public_path__ + "img/dropdown.89cbe868.svg";